<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Authorization Code</h4>
  <button type="button" class="btn-close" aria-label="Close dialog" (click)="dismissModal('Cross click')"></button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-12">
      <label class="textColor topic-to-left" for="authCode">
        Authorization Code<br />
        <span class="nav-thai-font">รหัสผ่าน</span>
      </label>
      <div class="auth-input-wrap">
        <input id="authCode" [type]="isHidePass ? 'password' : 'text'" (keydown.enter)="onSubmit()" minlength="6"
          required class="form-control" placeholder="Authorization Code" [(ngModel)]="isInputCode"
          (ngModelChange)="onChangeInput()" autocomplete="off" />
        <i class="fa auth-eye-icon cursor__point" [ngClass]="isHidePass ? 'fa-eye' : 'fa-eye-slash'" (click)="isShow()"
          role="button" [attr.aria-label]="isHidePass ? 'Show password' : 'Hide password'" tabindex="0"
          (keydown.enter)="isShow()"></i>
      </div>
      @if (isNotPass) {
      <small class="text-danger" role="alert">The code you entered is incorrect.</small>
      }
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="dismissModal('cancel click')">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="onSubmit()">Confirm</button>
</div>